<template>
    <div class="container">
        <div v-for="(item, index) in mediaList" :key="index" style="margin:10px;">
            <img :src="item.url" alt="" v-if="item.display" @click="goToShare(item.redirectUrl)">
        </div>
    </div>
</template>

<script setup lang="ts">
import { goToShare, MediaItem } from '@/view/home/supportScript';
import { ref, onMounted } from 'vue';

const props = defineProps<{
    itemData: {
        shareMediaList: MediaItem[]
    }
}>()
const mediaList = ref(props.itemData.shareMediaList)

onMounted(() => {
    mediaList.value = props.itemData.shareMediaList
})
</script>
<style scoped>
.container {
    display: flex;
    justify-content: center;
    padding: 8px 10px;
    border-radius: 9px;
    margin: 10px;
}

.container img {
    width: 30px;
    height: 30px;
}
</style>